module.exports = __webpack_public_path__ + "img/返回.bb991fb7.svg";